import React from 'react';
import { Grid, Tabs } from '@statsbomb/kitbag-components';
import { useReactiveVar } from '@apollo/client';
import {
  SummaryTile,
  SummaryTileBody,
} from '../../../components/Tile/TileSummary.styles';

import TeamRadarTile from './TeamRadar.Tile';
import TeamStatsTile from './TeamSchedule.Tile';
import { StyledTab } from './TeamOverview.styles';
import TeamFormationTile from './TeamFormation.Tile';
import TeamDepthTile from './TeamDepth.Tile';
import TeamPassingTile from './TeamPassing.Tile';
import TeamRunTendencies from './TeamRunTendencies.Tile';
import TeamLinePressure from './TeamLinePressure.Tile';
import TeamTacklingTile from './TeamTackling.Tile';
import useQueryString from '../../../utils/hooks/useQueryString';
import TeamHavocTile from './TeamHavoc.Tile';
import { KitbagPageGridHolder } from '../../../components/Layout/Layout.styles';
import PageHeader from '../../../components/PageHeader/PageHeader';
import TeamDefensiveSchemeTile from './TeamDefensiveScheme.Tile';
import { PAGE_HEADER_DISPLAY } from '../../../components/PageHeader/PageHeader.constants';
import { useTheme } from 'styled-components';
import { ui_TeamOverviewTab } from '../../../apollo';

const TeamOverview = () => {
  const theme = useTheme();
  const ui_TeamOverviewTabRV = useReactiveVar(ui_TeamOverviewTab);
  const [activeTabIndex, setActiveTabIndex] = useQueryString(
    'overview',
    ui_TeamOverviewTabRV
  );
  if (!window.location.search.includes('overview')) {
    setActiveTabIndex(ui_TeamOverviewTabRV);
  }
  const tabs = [
    {
      label: 'Offense',
      value: 0,
    },
    { label: 'Defense', value: 1 },
  ];

  return (
    <KitbagPageGridHolder>
      <Grid container={false} page>
        <Grid item xs={12}>
          <PageHeader titleType={PAGE_HEADER_DISPLAY.TEAM} />
        </Grid>

        <Grid item xs={6}>
          <TeamRadarTile />
        </Grid>
        <Grid item xs={6}>
          <TeamStatsTile />
        </Grid>

        <Grid item xs={12}>
          <SummaryTile>
            <SummaryTileBody $margin="0">
              <StyledTab>
                <Tabs
                  tabs={tabs}
                  activeTab={activeTabIndex}
                  onTabChange={(e, tab) => {
                    setActiveTabIndex(tab.value);
                    ui_TeamOverviewTab(tab.value);
                  }}
                />
              </StyledTab>
              <div style={{ padding: theme.sizing.medium }}>
                {activeTabIndex === 0 && (
                  <Grid>
                    <Grid item sm={12} lg={6} xl={3}>
                      <TeamFormationTile />
                    </Grid>
                    <Grid item sm={12} lg={6} xl={3}>
                      <TeamDepthTile />
                    </Grid>
                    <Grid item sm={12} lg={6} xl={3}>
                      <TeamPassingTile />
                    </Grid>
                    <Grid item sm={12} lg={6} xl={3}>
                      <TeamTacklingTile />
                    </Grid>
                    <Grid item sm={12} lg={12} xl={6}>
                      <TeamRunTendencies />
                    </Grid>
                    <Grid item sm={12} lg={12} xl={6}>
                      <TeamLinePressure />
                    </Grid>
                  </Grid>
                )}
                {activeTabIndex === 1 && (
                  <Grid>
                    <Grid item sm={12} lg={6} xl={3}>
                      <TeamDefensiveSchemeTile />
                    </Grid>
                    <Grid item sm={12} lg={6} xl={3}>
                      <TeamDepthTile offense={false} />
                    </Grid>
                    <Grid item sm={12} lg={6} xl={3}>
                      <TeamPassingTile offense={false} />
                    </Grid>
                    <Grid item sm={12} lg={6} xl={3}>
                      <TeamTacklingTile offense={false} />
                    </Grid>
                    <Grid item sm={12} lg={6} xl={3}>
                      <TeamHavocTile />
                    </Grid>
                  </Grid>
                )}
              </div>
            </SummaryTileBody>
          </SummaryTile>
        </Grid>
      </Grid>
    </KitbagPageGridHolder>
  );
};

export default TeamOverview;
